<template lang="pug">
.fancy-header.d-flex.flex-column.align-items-center.py-4.px-4
  img.background-img(:src='backgroundSrc')
  .title {{ title }}
</template>

<script>
export default {
  props: {
    title: {
      default: '...',
    },
    backgroundSrc: {
      default: '',
    },
  },
};
</script>

<style lang="scss">
.fancy-header {
  background: #ebebeb;
  .background-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
    height: 80px;
  }
  .title {
    font-size: 21px;
    color: #fff;
    z-index: 1;
  }
}
</style>
